import { render } from "./DashboardBestSellers.vue?vue&type=template&id=25d2dc21&scoped=true&ts=true"
import script from "./DashboardBestSellers.vue?vue&type=script&lang=ts"
export * from "./DashboardBestSellers.vue?vue&type=script&lang=ts"

import "./DashboardBestSellers.vue?vue&type=style&index=0&id=25d2dc21&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d2dc21"]])

export default __exports__